var map = {
	"./ac.png": "bbf8",
	"./appstoreAdd.png": "621d",
	"./back.png": "92ed",
	"./battery.png": "c83d",
	"./dateImg.png": "0c36",
	"./dateReportNav.png": "3130",
	"./disinfectNav.png": "2e3e",
	"./edition.png": "94bb",
	"./endnew.png": "4163",
	"./eq.png": "ec26",
	"./finishnew.png": "be87",
	"./logo.png": "266c",
	"./manageNav.png": "aedb",
	"./messages.png": "a975",
	"./network.png": "e880",
	"./noMap.png": "21c2",
	"./nodata.png": "4784",
	"./nodataArea.png": "6a60",
	"./offlineImg.png": "7074",
	"./offlineImg0.png": "d8d1",
	"./onlineImg.png": "6b81",
	"./purchases.png": "70c7",
	"./regionNav.png": "a475",
	"./robot.png": "6e5f",
	"./robotImg.png": "3f15",
	"./robotImg1.png": "8238",
	"./robotNav.png": "aa6a",
	"./shoppings.png": "1748",
	"./systemNav.png": "3022",
	"./task.png": "5188",
	"./time.png": "a579",
	"./user.png": "7026",
	"./userImg.png": "1274",
	"./visits.png": "01be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a53";